/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-bitwise */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input,
  Card, CardBody, Badge, Spinner,
} from 'reactstrap'
import moment from 'moment'
import Files from 'react-files'
import { notifyError } from '../../../utils/notify'
import PdfRender from '../../../components/Common/PdfReader'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { updateSolicitation, deletePendingSolicitation } from '../../../store/ducks/humanResources'
import { addFile, deleteFile } from '../../../store/ducks/files'
import { history } from '../../../store'

class ReplySolicitation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deleteSolicitationDialogIsOpen: false,
      solicitation: null,
      fileNumber: 0,
      reason: '',
      reasonInputError: '',
      reasonDialogIsOpen: false,

    }
    this.files = React.createRef()
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.solicitation) {
      const { solicitation } = this.props.location.state

      if (solicitation) {
        this.setState({ solicitation })
      }
    } else {
      history.push('/colaborador/solicitacoes')
    }
  }

  componentDidUpdate(prevProps) {
    // Arquivo excluído com sucesso
    if (
      prevProps.files.deleteFileSuccessId !== this.props.files.deleteFileSuccessId
      && !this.props.files.deleteFileError
      && !this.props.files.deleteFileIsLoading
    ) {
      this.setState({
        solicitation: {
          ...this.state.solicitation,
          files: this.state.solicitation.files.filter(file => file.id !== this.props.files.deleteFileSuccessId),
        },
        fileNumber: this.state.fileNumber > 0 ? this.state.fileNumber - 1 : 0,
      })
    }

    // Arquivo adicionado com sucesso
    if (
      prevProps.files.lastFileAdded !== this.props.files.lastFileAdded
      && this.props.files.addFileSucceeded
      && !this.props.files.addFileError
      && !this.props.files.addFileIsLoading
    ) {
      this.setState({
        solicitation: {
          ...this.state.solicitation,
          files: [
            ...this.state.solicitation.files || [],
            {
              id: this.props.files.lastFileAdded.arquivo_id,
              path: this.props.files.lastFileAdded.arquivo_caminho,
              extension: this.props.files.lastFileAdded.arquivo_caminho
                .slice((this.props.files.lastFileAdded.arquivo_caminho
                  .lastIndexOf('.') - 1 >>> 0) + 2),
            },
          ],
        },
        fileNumber:
          this.state.solicitation.files && this.state.solicitation.files.length > 0
            ? this.state.fileNumber + 1
            : 0,
      })
    }

    return true
  }

  formatStatus = status => {
    switch (status) {
      case '0':
        return <Badge className="badge-soft-info mr-1">Em análise</Badge>
      case '1':
        return <Badge className="badge-soft-success mr-1">Aprovada</Badge>
      case '2':
        return <Badge className="badge-soft-danger mr-1">Recusada</Badge>
      default:
        return null
    }
  }

  render() {
    const { updateSolicitation, deletePendingSolicitation, addFile, deleteFile } = this.props
    const { deleteFileIsLoading, addFileIsLoading } = this.props.files
    const {
      solicitation, deleteSolicitationDialogIsOpen, fileNumber,
      reason, reasonDialogIsOpen, reasonInputError,
    } = this.state

    if (!solicitation) return null

    return (
      <div className="page-content">
        <Modal
          centered
          isOpen={deleteSolicitationDialogIsOpen}
          toggle={() => this.setState({
            deleteSolicitationDialogIsOpen: !deleteSolicitationDialogIsOpen,
          })}
        >
          <ModalHeader
            toggle={() => this.setState({
              deleteSolicitationDialogIsOpen: !deleteSolicitationDialogIsOpen,
            })}
          >
            Excluir solicitação
          </ModalHeader>
          <ModalBody>
            Tem certeza que deseja excluir esta solicitação? Essa ação não poderá ser revertida.
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="light"
              onClick={() => this.setState({
                deleteSolicitationDialogIsOpen: !deleteSolicitationDialogIsOpen,
              })}
            >
              Voltar
            </Button>
            <Button
              type="button"
              color="danger"
              onClick={() => deletePendingSolicitation(solicitation.pend_id, solicitation.pend_tab)}
            >
              Excluir
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          centered
          isOpen={reasonDialogIsOpen}
          toggle={() => this.setState({ reasonDialogIsOpen: !reasonDialogIsOpen })}
        >
          <ModalHeader toggle={() => this.setState({ reasonDialogIsOpen: !reasonDialogIsOpen })}>
            Responder solicitação
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Justificativa</Label>
              <Input
                className="form-control"
                type="text"
                autoCapitalize="sentences"
                maxLength={500}
                value={reason}
                onChange={e => this.setState({
                  reason: e.target.value,
                  reasonInputError: '',
                })}
              />
              {reasonInputError && <span style={{ color: 'red' }}>{reasonInputError}</span>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="light"
              onClick={() => this.setState({ reasonDialogIsOpen: !reasonDialogIsOpen })}
            >
              Voltar
            </Button>
            <Button
              type="button"
              color="primary"
              onClick={() => {
                if (!reason) return this.setState({ reasonInputError: 'Campo obrigatório.' })
                return updateSolicitation({
                  type: 0,
                  solicitation: {
                    ...solicitation,
                    reason,
                  },
                })
              }}
            >
              Responder
            </Button>
          </ModalFooter>
        </Modal>

        <Container fluid>

          <Row>
            <Col className="d-flex">
              <Breadcrumbs
                title="Solicitação"
                breadcrumbItems={[]}
              />
              <div
                style={{
                  marginTop: 13,
                  marginLeft: 14,
                }}
              >
                <Badge className="badge-soft-dark mr-1">
                  #
                  {solicitation.pend_id}
                </Badge>
              </div>
              <div
                style={{
                  marginTop: 13,
                  marginLeft: 10,
                }}
              >
                {this.formatStatus(solicitation.pend_aprov)}
              </div>
            </Col>
          </Row>

          <Row>
            <Col xl={4} lg={4} md={4} sm={4}>
              <div
                className="d-flex align-items-end"
                style={{ height: 29, marginBottom: 12 }}
              >
                <span style={{ fontWeight: 600 }}>
                  Informações
                </span>
              </div>

              <Card>
                <CardBody>
                  {/* Comum a todos */}

                  <FormGroup>
                    <Label>Data de solicitação</Label>
                    <Input
                      disabled
                      value={moment(solicitation.pend_dt_sol).format('DD/MM/YYYY')}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label>Assunto</Label>
                    <Input
                      disabled
                      value={solicitation.pend_assunto}
                    />
                  </FormGroup>

                  {/* Despesas */}

                  {solicitation.pend_assunto === 'Despesa' && (
                    <>
                      <FormGroup>
                        <Label>Rubrica</Label>
                        <Input
                          disabled
                          value={solicitation.rubrica_nome}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Descrição</Label>
                        <Input
                          disabled
                          value={solicitation.mov_desc}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Valor</Label>
                        <MaskedInput
                          disabled
                          value={solicitation.mov_vlr}
                        />
                      </FormGroup>
                    </>
                  )}

                  {/* Ponto retroativo */}

                  {solicitation.pend_assunto === 'Retroativo' && (
                    <>
                      <FormGroup>
                        <Label>Data do expediente retroativo</Label>
                        <Input
                          disabled
                          value={moment(solicitation.pend_dt).format('DD/MM/YYYY')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Setor ou Projeto</Label>
                        <Input
                          disabled
                          value={solicitation.proj_nome}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Atividade ou Produto</Label>
                        <Input
                          disabled
                          value={solicitation.pontoAtiv_ativ}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Descrição</Label>
                        <Input
                          disabled
                          value={solicitation.pontoAtiv_desc}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Tempo dedicado</Label>
                        <Input
                          disabled
                          value={solicitation.pontoAtiv_tempo}
                        />
                      </FormGroup>
                    </>
                  )}

                  {/* Férias */}

                  {solicitation.pend_assunto === 'Férias' && (
                    <>
                      <FormGroup>
                        <Label>Data de início</Label>
                        <Input
                          disabled
                          value={solicitation.pend_dt_ini}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Data de encerramento</Label>
                        <Input
                          disabled
                          value={solicitation.pend_dt_fim}
                        />
                      </FormGroup>
                    </>
                  )}

                  {/* Atestado/Ausência */}

                  {solicitation.pend_assunto === 'Atestado' && (
                    <>
                      <FormGroup>
                        <Label>Data inicial</Label>
                        <Input
                          disabled
                          value={solicitation.pend_dt_ini}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Data final</Label>
                        <Input
                          disabled
                          value={solicitation.pend_dt_fim}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Descrição</Label>
                        <Input
                          disabled
                          value={solicitation.pontoAtiv_justif}
                        />
                      </FormGroup>
                    </>
                  )}

                  {/* Comum à todos */}

                  <FormGroup>
                    <Label>Justificativa</Label>
                    <Input
                      disabled
                      value={solicitation.pend_justif}
                    />
                  </FormGroup>
                </CardBody>
              </Card>

            </Col>

            <Col>
              <div
                className="d-flex align-items-end justify-content-between"
                style={{ height: 29, marginBottom: 12 }}
              >
                <div>
                  <span style={{ fontWeight: 600 }}>
                    Anexos
                  </span>
                  {solicitation.files && solicitation.files.length > 0 && (
                    <span style={{ fontWeight: 600 }}>
                      {` (${fileNumber + 1} de ${solicitation.files.length})`}
                    </span>
                  )}
                </div>
                <div className="d-flex">
                  {solicitation.files && solicitation.files.length > 0 && (
                    <>
                      <Button
                        disabled={fileNumber === 0}
                        size="sm"
                        color="info"
                        className="ml-4"
                        onClick={() => this.setState({ fileNumber: fileNumber - 1 })}
                      >
                        <i className="ri-arrow-left-s-line font-size-10" />
                        {' '}
                        Anterior
                      </Button>
                      <Button
                        disabled={fileNumber + 1 === solicitation.files.length}
                        size="sm"
                        color="info"
                        className="ml-2"
                        onClick={() => this.setState({ fileNumber: fileNumber + 1 })}
                      >
                        Próximo
                        {' '}
                        <i className="ri-arrow-right-s-line font-size-10" />
                      </Button>
                      {solicitation.pend_aprov === '2' && (
                        <Button
                          disabled={deleteFileIsLoading || addFileIsLoading}
                          size="sm"
                          color="info"
                          className="ml-3"
                          onClick={() => deleteFile(solicitation.files[fileNumber].id)}
                        >
                          <i className="ri-delete-bin-6-line align-middle mr-2" />
                          <span className="align-middle">Excluir arquivo</span>
                        </Button>
                      )}
                    </>
                  )}
                  {solicitation.pend_aprov === '2' && (
                    <Button
                      size="sm"
                      color="info"
                      className="ml-3"
                      disabled={(solicitation.files && solicitation.files.length >= 3) || deleteFileIsLoading || addFileIsLoading}
                    >
                      <Files
                        clickable
                        multiple={false}
                        ref={this.files}
                        onChange={files => {
                          addFile({
                            tabRef: solicitation.pend_tab,
                            tabId: solicitation.pend_id,
                            desc: `Anexo à solicitação #${solicitation.pend_id}`,
                            file: files[0],
                          })
                        }}
                        onError={(error) => notifyError(error.message)}
                        accepts={['image/png', 'image/jpg', 'image/jpeg', '.pdf']}
                        maxFileSize={10000000}
                        minFileSize={1}
                      >
                        <i className="ri-attachment-2 align-middle mr-2" />
                        <span className="align-middle">Adicionar arquivos</span>
                      </Files>
                    </Button>
                  )}
                </div>
              </div>

              <Card>
                <Col className="d-flex align-items-center justify-content-center p-3">
                  {addFileIsLoading && (
                    <div className="d-flex align-items-center justify-content-center">
                      <Spinner />
                      <span style={{ padding: 25 }}>Subindo arquivo...</span>
                    </div>
                  )}
                  {!addFileIsLoading && (!solicitation.files || solicitation.files.length <= 0) && (
                    <span style={{ padding: 25 }}>Esta solicitação não possui anexos.</span>
                  )}
                  {!addFileIsLoading && solicitation.files && solicitation.files.length > 0 && solicitation.files[fileNumber].extension === 'pdf' && (
                    <PdfRender data={`https://oikos.ecoss.is/oikos/${solicitation.files[fileNumber].path}`} />
                  )}
                  {
                    !addFileIsLoading
                    && solicitation.files
                    && solicitation.files.length > 0
                    && (
                      solicitation.files[fileNumber].extension === 'png'
                      || solicitation.files[fileNumber].extension === 'jpg'
                      || solicitation.files[fileNumber].extension === 'jpeg'
                    )
                    && (
                      <img
                        src={`https://oikos.ecoss.is/oikos/${solicitation.files[fileNumber].path}`}
                        alt="Imagem anexa à solicitação"
                        style={{ maxHeight: 514, maxWidth: 800 }}
                      />
                    )
                  }
                </Col>
              </Card>

            </Col>
          </Row>

          {solicitation.pend_aprov === '2' && (
            <>
              <Row>
                <Col>
                  <hr className="mt-2 mb-4" />
                </Col>
              </Row>

              <Row>
                <Col className="d-flex justify-content-end">
                  <Button
                    type="button"
                    color="danger"
                    className="w-md"
                    onClick={() => this.setState({ deleteSolicitationDialogIsOpen: true })}
                  >
                    Excluir
                  </Button>
                  <Button
                    type="button"
                    color="primary"
                    className="ml-3 w-md"
                    onClick={() => this.setState({ reasonDialogIsOpen: true })}
                  >
                    Responder
                  </Button>
                </Col>
              </Row>
            </>
          )}

        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  humanResources: state.humanResources,
  files: state.files,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  updateSolicitation,
  deletePendingSolicitation,
  addFile,
  deleteFile,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(ReplySolicitation)
